import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cubicBezier, motion } from 'framer-motion';

import { H1, StringSmall } from '@/components/Typography/Typography';

const MotionTitleAndDescription: FC = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        delay: 0.8,
        ease: cubicBezier(0.68, -0.55, 0.27, 1.55),
        duration: 0.3,
      }}
      className="flex flex-col items-center mb-7"
    >
      <H1 weight="extrabold" className="mb-2">
        {t('Congrats!')}
      </H1>
      <StringSmall weight="regular" className="!text-white/60 mb-6">
        {t('You have opened a prestige container')}
      </StringSmall>
    </motion.div>
  );
};

export { MotionTitleAndDescription };
